import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {LoginService} from '../../../services/login.service';
import {SweetUtil} from '../sweet/sweet-util-service';
import {FeatureToggleService} from '../../../toggle/feature-toggle.service';

@Component({
  selector: 'app-eam',
  templateUrl: './eam.component.html',
  styleUrls: ['./eam.component.css']
})
export class EamComponent implements OnInit {

  sub: any;
  loginValid = true;
  webeamRoleValidation: boolean;

  constructor(private route: ActivatedRoute, private loginService: LoginService,
              private router: Router, private sweetUtil: SweetUtil, private featureToggleService: FeatureToggleService) {
  }

  ngOnInit(): void {
    this.sub = this.route.fragment.subscribe(q => {
      const accessToken = q.substring(q.indexOf('access_token=') + 13, q.indexOf('&'));
      const s = q.substring(q.indexOf('&') + 1, q.length);
      const idToken = s.substring(s.indexOf('id_token=') + 9, s.indexOf('&'));

      sessionStorage.setItem('access_token', accessToken);
      sessionStorage.setItem('id_token', idToken);
      this.loginService.loginUser().subscribe(() => {
        this.loginService.handleLogin()
        this.router.navigate(['/dashboard']).then();
      });
    }, error => {
      if (error.status === 401) {
        this.loginValid = false;
        this.sweetUtil.showError(error.error);
      }
    });
  }

  getError() {
    if (this.webeamRoleValidation) {
      return 'web-eam-role-validation';
    } else {
      return 'Invalid login. Please try again.';
    }
  }
}
